import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { NavParams, ToastController, ViewController } from "ionic-angular";
import { CategoriesData } from "../../../../providers/categories";
import { GenFormBuilder } from "../../../../providers/form";
import { Utilities } from "../../../../providers/utilities";
import { ICategory } from "../../../../shared/models/categories.model";

@Component({
  selector: "app-categories-form",
  templateUrl: "categories-form.component.html",
})

export class CategoriesFormComponent implements OnInit {

  public form: FormGroup;

  public submitAttempt: boolean = false;

  public clientId: string;

  public category: ICategory;

  constructor(
    private viewCtrl: ViewController,
    private formBuilder: FormBuilder,
    private genForm: GenFormBuilder,
    private categoriesData: CategoriesData,
    private toastController: ToastController,
    private navParams: NavParams,
    private utilities: Utilities,
  ) { }

  public ngOnInit() {
    this.clientId = this.navParams.get("clientId");
    this.category = this.navParams.get("category");
    this.buildForm();
  }

  public onFormSubmitted({ value, valid }: { value: any; valid: boolean }) {
    this.submitAttempt = true;
    if (valid) {
      const load = this.utilities.setLoading();
      this.categoriesData.createCategory(this.clientId, value)
        .then(() => {
          this.toastController.create({
            duration: 3000,
            message: "The category was succesfully created",
          }).present();
          this.viewCtrl.dismiss()
            .then(() => load.dismiss());
        });
    }
  }

  private buildForm() {
    this.form = this.formBuilder.group({});
    this.genForm.genInputString("id", this.form);
    this.genForm.genInputString("name", this.form, true);
    this.genForm.genInputString("icon", this.form, true);
    this.genForm.genToggle("state", this.form);
    this.patchForm();
  }

  private patchForm() {
    if (this.category) {
      this.form.patchValue(this.category);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/categories/components/categories-form/categories-form.component.ts